import BaseEntity from './BaseEntity';
import PullRequest from './PullRequest';
export default class PullRequestList extends BaseEntity {
    constructor(pullRequestList) {
        super();
        this.pullRequests = [];
        if (pullRequestList.length) {
            this.pullRequests = pullRequestList.map((pullRequest) => new PullRequest(pullRequest));
        }
    }
    getCommitsPercentage() {
        const commitsPercentage = {};
        for (const pullRequest of this.pullRequests) {
            const commit = pullRequest.sourceCommit;
            if (commit) {
                commitsPercentage[commit.id] = commit.getAnalysisPercentage();
            }
        }
        return commitsPercentage;
    }
    hasAnyRunningAnalysis() {
        for (const pullRequest of this.pullRequests) {
            if (pullRequest.sourceCommit?.isAnalysisStillRunning()) {
                return true;
            }
        }
        return false;
    }
}
